import { defineStore } from "pinia";
import { ref } from "vue";
import { useRest } from "@/composables/useRest";

export const useIdentificationTypeStore = defineStore("identificationType", () => {
  const identificationType = ref([]);
  const identificationTypeListLoad = ref(false);
  const url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/parametros/tipo-documento`;

  const rest = useRest();

  async function setIdentificationType() {
    try {
      const r = await rest.get({ url });
      const datos = r.data.data.map((element) => ({
        name: element.Nombre,
        description: element.Descripcion,
        id: element.TipodocumentoID,
      }));
      identificationType.value = datos;
    } catch (e) {
      console.error("setIdentificationType>>", e);
    } finally {
      identificationTypeListLoad.value = true;
    }
  }

  return {
    identificationType,
    identificationTypeListLoad,
    setIdentificationType,
  };
});
